module.exports = __webpack_public_path__ + "img/feature-10.a275dd0f.png";